exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".aroundbtn{padding:20px;border-radius:200px;position:absolute;display:block;top:20px;left:20px;z-index:100000;background-color:rgba(0,0,0,.6);color:#fff}", ""]);
